import React, { useState, useEffect } from "react"
import { get, post, put, remove } from "./../utils/apiClient"
import toast from "react-hot-toast"
import Pagination from "./common/pagination"
import { SquarePen, Trash2 } from "lucide-react"

const FolderManagement = ({
  selectedFolderMng,
  setSelectedFolderMng,
  setQueueToReload,
}) => {
  const [folders, setFolders] = useState([])
  const [showPopup, setShowPopup] = useState(false)
  const [folderToEdit, setFolderToEdit] = useState(null)
  const [currentPage, setCurrentPage] = useState(1)
  const [loading, setLoading] = useState(false)
  const [actionLoading, setActionLoading] = useState(false)
  const [folderIdToDelete, setFolderIdToDelete] = useState(null)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [searchText, setSearchText] = useState("")

  // Search Filter
  const filteredFolders = folders?.filter((folder) => {
    return Object.entries(folder).some(([key, value]) => {
      // For other fields, apply standard filtering
      if (key === "subFolder") {
        return value
          ?.toString()
          .toLowerCase()
          .includes(searchText.toLowerCase())
      }
    })
  })

  const startIdx = (currentPage - 1) * rowsPerPage
  const currentFolders = filteredFolders.slice(startIdx, startIdx + rowsPerPage)
  const totalPages = Math.ceil(filteredFolders.length / rowsPerPage)

  // const currentFaxes = sortedFaxes.slice(startIdx, startIdx + rowsPerPage)
  // const totalPages = Math.ceil(filteredFaxes.length / rowsPerPage)

  useEffect(() => {
    loadFolder()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFolderMng])

  const fetchFolders = async () => {
    try {
      let url = `/admin/netId-subfolder-associations?netId=${selectedFolderMng.netId}`
      if (selectedFolderMng.sectionType === "queue") {
        url = `/admin/queue-subfolder-associations?queueName=${selectedFolderMng.queue}`
      }

      const data = await get(url)

      const dataFilterTrash = data.filter((d) => d.subFolder !== "Trash")

      setFolders(dataFilterTrash)
    } catch (error) {
      console.error("Failed to fetch folders", error)
    }
  }

  const loadFolder = async () => {
    setLoading(true)
    await fetchFolders()
    setLoading(false)
  }

  const handleAddFolder = async (data) => {
    setActionLoading(true)

    const isEdit = data.actionType === "edit" ? true : false

    let url = `/admin/netId-subfolder-association`
    if (selectedFolderMng.sectionType === "queue") {
      url = `/admin/queue-subfolder-association`
    }

    try {
      if (isEdit) {
        let paramsPut = {
          netId: data.netId,
          oldSubFolder: data.oldSubFolder,
          newSubFolder: data.newSubFolder,
        }

        if (selectedFolderMng.sectionType === "queue") {
          paramsPut = {
            queueName: data.queueName,
            oldSubFolder: data.oldSubFolder,
            newSubFolder: data.newSubFolder,
          }
        }

        await put(url, paramsPut)
      } else {
        let paramsPost = {
          netId: data.netId,
          subFolder: data.newSubFolder,
        }

        if (selectedFolderMng.sectionType === "queue") {
          paramsPost = {
            queueName: data.queueName,
            subFolder: data.newSubFolder,
          }
        }

        await post(url, paramsPost)
      }

      fetchFolders()
      setShowPopup(false)
      setFolderToEdit(null)
      toast.success(`Folder ${isEdit ? "updated" : "added"} successfully`)
    } catch (error) {
      console.error(`Failed to ${isEdit ? "update" : "add"} folder`, error)
      toast.error(error)
    } finally {
      setActionLoading(false)
    }
  }

  const handleDeleteFolder = async () => {
    setActionLoading(true)
    try {
      let url = `/admin/netId-subfolder-copied-faxes-association/${folderIdToDelete.netId}/${folderIdToDelete.subFolder}`
      if (selectedFolderMng.sectionType === "queue") {
        url = `/admin/queue-subfolder-copied-faxes-association/${folderIdToDelete.queueName}/${folderIdToDelete.subFolder}`
      }

      await remove(url)
      fetchFolders()
      setFolderIdToDelete(null)
      toast.success("Folder removed successfully")
    } catch (error) {
      console.error("Failed to delete folder", error)
      toast.error("Something went wrong")
    } finally {
      setActionLoading(false)
    }
  }

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        minWidth: "500px",
        padding: "20px",
      }}
    >
      {loading ? (
        <div className="loading-container-fax-list">
          <div className="loading-message">Loading...</div>
        </div>
      ) : (
        <div
          className="faxes-content"
          style={{
            textAlign: "left",
            width: "100%",
          }}
        >
          <div
            // className="search-container"
            style={{
              width: "100%",
              alignItems: "top",
              display: "flex",
              justifyContent: "space-between",
              paddingBottom: "10px",
            }}
          >
            <div className="setting-note">
              <button
                title="Click to go back"
                onClick={() => {
                  setQueueToReload(selectedFolderMng)
                  setSelectedFolderMng(null)
                }}
                style={{ fontSize: "18px", cursor: "pointer" }}
              >
                🔙
              </button>
              <span style={{ fontWeight: "bold", paddingLeft: "10px" }}>
                Folder Management - [
                {selectedFolderMng.sectionType === "queue"
                  ? selectedFolderMng.queue
                  : selectedFolderMng.netId}
                ]
              </span>

              {/* <div>
                <input
                  type="text"
                  placeholder={`Search Folders`}
                  value={searchText}
                  onChange={(e) => {
                    setSearchText(e.target.value)
                    setCurrentPage(1)
                  }}
                />
              </div> */}
            </div>
            {selectedFolderMng.permissions.WRITE.FAX_CREATE && (
              <button
                className="faxes-button"
                onClick={() => setShowPopup(true)}
                style={{ marginBottom: "5px" }}
              >
                + Add Folder
              </button>
            )}
          </div>
          <div className="table-container">
            <table className="faxes-table">
              <thead>
                <tr>
                  <th className="faxes-th">Folder Name</th>
                  {/* <th className="faxes-th">Secret</th> */}
                  <th
                    className="faxes-th"
                    style={{ textAlign: "center", width: "100px" }}
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentFolders.length > 0 ? (
                  currentFolders.map((folder) => (
                    <tr
                      key={folder.folderId}
                      className="fax-item"
                      style={{ cursor: "unset" }}
                    >
                      <td className="faxes-td">{folder.subFolder}</td>
                      <td className="faxes-td" style={{ textAlign: "center" }}>
                        {selectedFolderMng.permissions.WRITE.FOLDER_RENAME && (
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => setFolderToEdit(folder)}
                          >
                            <SquarePen size="18" color="black" />
                          </span>
                        )}
                        {selectedFolderMng.permissions.DELETE.FOLDER_DELETE && (
                          <span
                            style={{ cursor: "pointer", marginLeft: "10px" }}
                            onClick={() => setFolderIdToDelete(folder)}
                          >
                            <Trash2 size="18" color="red" />
                          </span>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="100%"
                      style={{
                        textAlign: "center",
                        padding: "10px",
                        border: "1px solid #ccc",
                      }}
                    >
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {filteredFolders.length > 0 && (
            <div
              className="faxes-pagination"
              style={{
                marginTop: "0px",
                display: "flex",
                justifyContent: "end",
              }}
            >
              {filteredFolders.length > 0 && (
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  rowsPerPage={rowsPerPage}
                  totalRows={filteredFolders.length}
                  onPageChange={(page) => setCurrentPage(page)}
                  onRowsPerPageChange={(count) => {
                    setRowsPerPage(count)
                    setCurrentPage(1) // Reset to first page on change
                  }}
                />
              )}
            </div>
          )}
        </div>
      )}

      {(showPopup || folderToEdit) && (
        <FolderForm
          onSave={handleAddFolder}
          onClose={() => {
            setShowPopup(false)
            setFolderToEdit(null)
          }}
          folderToEdit={folderToEdit}
          actionLoading={actionLoading}
          selectedFolderMng={selectedFolderMng}
        />
      )}

      {folderIdToDelete && (
        <DeleteConfirmationPopup
          onConfirm={handleDeleteFolder}
          onCancel={() => setFolderIdToDelete(null)}
          actionLoading={actionLoading}
          folderIdToDelete={folderIdToDelete}
        />
      )}
    </div>
  )
}

const FolderForm = ({
  onClose,
  onSave,
  folderToEdit,
  actionLoading,
  selectedFolderMng,
}) => {
  const [folderName, setFolderName] = useState("")

  const [errorMessage, setErrorMessage] = useState("")

  // Load initial data if editing
  useEffect(() => {
    if (folderToEdit) {
      setFolderName(folderToEdit?.subFolder)
    }
  }, [folderToEdit])

  const handleSubmit = (e) => {
    e.preventDefault()

    if (!folderName.trim()) {
      setErrorMessage("Folder Name is required.")
      return
    }

    onSave({
      queueSubfolderId: folderToEdit?.queueSubfolderId || null,
      folderName,
      queueName: selectedFolderMng?.queue,
      netId: selectedFolderMng?.netId,
      oldSubFolder: folderToEdit?.subFolder,
      newSubFolder: folderName,
      actionType: folderToEdit ? "edit" : "add",
    })
  }

  return (
    <div className="popup-overlay">
      <div className="popup">
        <div className="checkbox-popup-header">
          <h3 className="popup-title">
            {folderToEdit ? `Update` : `Add`} Folder
          </h3>
          <button
            type="button"
            onClick={onClose}
            style={{
              background: "transparent",
              border: "none",
              fontSize: 24,
              cursor: "pointer",
            }}
          >
            ×
          </button>
        </div>

        <form className="popup-group" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="folderName">
              Folder Name: <span className="mandatory">*</span>
            </label>
            <input
              type="text"
              id="folderName"
              value={folderName}
              onChange={(e) => {
                setFolderName(e.target.value.trim())
                setErrorMessage("")
              }}
            />
          </div>

          {errorMessage && <div className="error-message">{errorMessage}</div>}

          <div className="popup-buttons">
            <button
              className="popup-button cancel"
              type="button"
              onClick={onClose}
            >
              Cancel
            </button>
            <button className="popup-button save" type="submit">
              {actionLoading ? `Saving ...` : "Save"}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

const DeleteConfirmationPopup = ({
  onConfirm,
  onCancel,
  actionLoading,
  folderIdToDelete,
}) => (
  <div className="popup-overlay">
    <div className="popup" style={{ padding: "20px", maxWidth: "700px" }}>
      {actionLoading ? (
        <div>Processing...</div>
      ) : (
        <>
          {/* <h3>Confirm Deletion</h3> */}
          <p>
            Are you sure you want to delete the folder{" "}
            <strong>{folderIdToDelete?.subFolder}?</strong>
          </p>
          {/* <p>
            ⚠️ Deleting this folder will clean up all related associations —
            including fax numbers, admin, and user. This action is irreversible.
          </p> */}
          <div className="popup-buttons">
            <button className="cancel" onClick={onCancel}>
              Cancel
            </button>
            <button className="delete" onClick={onConfirm}>
              Delete
            </button>
          </div>
        </>
      )}
    </div>
  </div>
)

export default FolderManagement
